import { auth0 } from "@/services/auth0";
import { AdminRole } from "@upclaim/sdk/src/extra-types"

export function getUserRoles() : Array<AdminRole> {
  const { user } = auth0;
  const userRoles: AdminRole[] = user.value?.["https://netlify-integration.com/roles"];
  return userRoles || [];
}